import { useState } from 'react'
import { Table } from 'react-bootstrap'
// import ShimmerTable from '../Shimmer/ShimmerTable'
import './CommonTable.scss'
import { DoubleArrowIcon, SortIcon } from '../../../assets/Svg/SvgImages'
import NoRecord from '../NoRecord/NoRecord'

const CommonTable = ({ className, fields, sortbuttons, children, noRecordFound, loading, doubleicon, checkIcon, ref }) => {
  const [active, setActive] = useState(false)
  const [double, setdouble] = useState(false)
  return (
    <div className="tableless">
      <Table responsive className={`commonTable mb-0 ${className}`}>
        {fields && (
          <thead>
            <tr>
              {fields?.map((item) => (
                <th key={item}>
                  <div className="d-flex align-itmes-center">
                    {item}
                    {sortbuttons && (
                      <span
                        onClick={() => setActive(!active)}
                        className={`sort_icon ${active ? 'up_active' : 'down_active'}`}
                      >
                        <SortIcon />
                      </span>
                    )}
                    {doubleicon && (
                      <span
                        onClick={() => setdouble(!double)}
                        className={`doubleiconIcon ${!double ? 'up_active' : 'down_active'}`}
                      >
                        <DoubleArrowIcon />
                      </span>
                    )}
                  </div>
                </th>
              ))}
            </tr>
          </thead>
        )}

        {!loading ? (
          <tbody>
            {children?.length ? (
              children
            ) : (
              <tr className="no_record text-center">
                <td colSpan={fields?.length}>{noRecordFound || <NoRecord text="Records" loading={loading} />}</td>
              </tr>
            )}
          </tbody>
        ) : (
          ''
        )}
        {/* {loading ? (
          <tbody>
            {Array.from({ length: 5 }, (_, i) => (
              <ShimmerTable fields={fields}/>
            ))}
          </tbody>
        ) : (
          ' '
        )} */}
      </Table>
    </div>
  )
}

export default CommonTable
